module.exports = __webpack_public_path__ + "components/advertise-header/static/c__card--4@2-c4cc77b8415af4f4db4171b9fd498c69.jpg";